import { Plane, Map, Mountain, Clock } from "lucide-react";
import { useLang } from "@/lib/i18n";

const ICONS = [Plane, Map, Mountain, Clock];

export default function Services() {
  const { t } = useLang();
  const items = t("services.items");
  return (
    <section id="services" data-testid="services-section" className="relative py-28 lg:py-32 px-6 lg:px-10 bg-[#050505]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-4">{t("services.eyebrow")}</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white font-light tracking-tight max-w-2xl">
              {t("services.title")}
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md leading-relaxed">{t("services.sub")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className="group relative bg-[#0d0d0d] border border-white/10 rounded-xl p-8 transition-all duration-500 hover:-translate-y-1 hover:border-[#C5A059]/40 hover:shadow-[0_0_40px_rgba(197,160,89,0.08)]"
              >
                <Icon className="w-7 h-7 text-[#C5A059] mb-8 stroke-[1.25]" />
                <h3 className="font-display text-2xl text-white font-normal mb-3">{s.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{s.body}</p>
                <div className="absolute bottom-0 left-8 right-8 h-px bg-gradient-to-r from-transparent via-[#C5A059]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
